// Oliver Sweeney — AJAX Cart helper
// Replaces axios-based AjaxCart.js with native fetch. No dependencies.

class OSCart {
  static _rand() {
    return Math.floor(100000000 + Math.random() * 900000000)
  }

  static async _get(url) {
    const response = await fetch(url)
    return { data: await response.json(), status: response.status }
  }

  static async _post(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    return { data: await response.json(), status: response.status }
  }

  static async getCart() {
    return this._get(`/cart.js?cache=${this._rand()}`)
  }

  static async getProduct(handle) {
    return this._get(`/products/${handle}.js?cache=${this._rand()}`)
  }

  static async addItem(payload) {
    const product = await this._post(`/cart/add.js?cache=${this._rand()}`, payload)
    const cart    = await this.getCart()
    if (cart.status === 200) {
      document.dispatchEvent(new CustomEvent('cartItemAdded', { detail: cart }))
    }
    return { cart, product }
  }

  static async changeItem(payload) {
    return this._post(`/cart/change.js?cache=${this._rand()}`, payload)
  }

  static async updateItems(payload) {
    return this._post(`/cart/update.js?cache=${this._rand()}`, { updates: payload })
  }

  static async updateCart(payload) {
    return this._post(`/cart/update.js?cache=${this._rand()}`, payload)
  }

  static async removeItem(id) {
    const product = await this._post(`/cart/change.js?cache=${this._rand()}`, { id: String(id), quantity: 0 })
    const cart    = await this.getCart()
    return { cart, product }
  }
}

window.OSCart = OSCart
